<template>
  <div class="page">
    <div class="page-padding">
      <figure class="visual">
        <picture>
          <source media="(min-width: 550px)" srcset="img/visual-news.jpg">
          <img src="img/visual-news-small.jpg"/>
        </picture>
        <figcaption>
          <h1>Bahnwelt TV</h1>
          <p>Faszinierende Filme aus der Welt der Eisenbahn</p>
        </figcaption>
      </figure>
      <h2 class="carousel-headline">Unsere aktuellen Filme</h2>
      <new-movies-list></new-movies-list>
    </div>
  </div>
</template>

<script>

import NewMoviesList from './NewMoviesList.vue';

export default {
  components: {
    newMoviesList: NewMoviesList
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  created: function () {
    // document.getElementById('nav').getElementsByTagName('a')[1].focus();

    //this.$nextTick(function () {
    //  document.getElementsByClassName('is-active')[0].focus()
    //});

  },
}

</script>



// WEBPACK FOOTER //
// Start.vue?0d924747